import _ from "lodash";
import * as XLSX from "xlsx";
import {EXCEL_EXTENSION, EXCEL_SHEET_NAME_LIMIT, KEY, TEMPLATE_FILE_NAME} from "../../constant";
import BaseExcelWriter from "./BaseExcelWriter";

export default class I18NextExcelWriter extends BaseExcelWriter {
    generateFromFile = file => {
        return new Promise(resolve => {
            const reader = new FileReader();
            reader.onload = event => {
                const data = [[KEY, ...this.languageCodes.map(code => code.name)]];
                const values = JSON.parse(event.target.result);
                for (const key in values) {
                    let checkedKey = key;
                    if (this.keyMacro) {
                        checkedKey = this.keyMacro(checkedKey);
                        if (typeof checkedKey !== "string" || !checkedKey) {
                            checkedKey = key;
                        }
                    }
                    let checkedValue = values[key];
                    if (this.valueMacro) {
                        checkedValue = this.valueMacro(checkedValue);
                        if (typeof checkedValue !== "string" || !checkedValue) {
                            checkedValue = this.valueMacro(checkedValue);
                        }
                    }
                    checkedValue = checkedValue.replace(/\\"/g, "\"").replace(/\\n|([^\\])\\n/g, "$1\n").replace(/\\\\/g, "\\");
                    data.push([checkedKey, checkedValue]);
                }
                const workbook = XLSX.utils.book_new();
                const sheet = XLSX.utils.aoa_to_sheet(data);
                XLSX.utils.book_append_sheet(workbook, sheet, file.name.replace(".json", ""));
                resolve(XLSX.writeFile(workbook, `${TEMPLATE_FILE_NAME}.${EXCEL_EXTENSION}`));
            };
            reader.readAsText(file);
        });
    };

    mergeWithFiles = (data) => {
        return new Promise(resolve => {
            const newData = _.cloneDeep(data);
            const readActions = [];
            let count = 0;
            const getOnloadHandler = (columnIndex, sheetData, sheetName) => {
                return event => {
                    const values = JSON.parse(event.target.result);
                    for (const key in values) {
                        let checkedKey = key;
                        if (this.keyMacro) {
                            checkedKey = this.keyMacro(checkedKey);
                            if (typeof checkedKey !== "string" || !checkedKey) {
                                checkedKey = key;
                            }
                        }
                        let checkedValue = values[key];
                        if (this.valueMacro) {
                            checkedValue = this.valueMacro(checkedValue);
                            if (typeof checkedValue !== "string" || !checkedValue) {
                                checkedValue = this.valueMacro(checkedValue);
                            }
                        }
                        checkedValue = checkedValue.replace(/\\"/g, "\"").replace(/\\n|([^\\])\\n/g, "$1\n").replace(/\\\\/g, "\\").replace(/<br>\n?/g, "\n");
                        let rowIndex = -1;
                        for (let i = 1; i < sheetData.length; i++) {
                            if (sheetData[i][0] === checkedKey) {
                                rowIndex = i;
                                break;
                            }
                        }
                        if (rowIndex < 0) {
                            rowIndex = sheetData.length;
                            const array = [checkedKey];
                            array[columnIndex] = checkedValue;
                            sheetData.push(array);
                        } else {
                            sheetData[rowIndex][columnIndex] = checkedValue;
                        }
                    }
                    newData[sheetName] = sheetData;
                    if (++count >= readActions.length) {
                        resolve(newData);
                    }
                };
            };
            for (const file of this.files) {
                let sheetName = file.webkitRelativePath.replace(/(.+\/)*(.+)\/(.+)\.json$/, "$3");
                if (sheetName.length > EXCEL_SHEET_NAME_LIMIT) {
                    sheetName = sheetName.slice(0, EXCEL_SHEET_NAME_LIMIT);
                }
                const sheetData = newData[sheetName] || [[KEY]];
                const language = file.webkitRelativePath.replace(/(.+\/)*(.+)\/.+\.json$/, "$2");
                const languageCode = this.languageCodes.find(value => value.i18next === language);
                if (languageCode) {
                    const header = languageCode.name;
                    let columnIndex = sheetData[0].findIndex(value => value === header);
                    if (columnIndex < 0) {
                        columnIndex = sheetData[0].length;
                        sheetData[0].push(header);
                    }
                    newData[sheetName] = sheetData;
                    const reader = new FileReader();
                    reader.onload = getOnloadHandler(columnIndex, sheetData, sheetName);
                    readActions.push(() => {
                        reader.readAsText(file);
                    });
                }
            }
            if (readActions.length > 0) {
                for (const action of readActions) {
                    action();
                }
            } else {
                resolve(newData);
            }
        });
    };
}
